"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModal = exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner.index"));

var _Modal = require("./Modal.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useModal = function useModal(_ref) {
  var isOpenParam = _ref.isOpen,
      isLoadingParam = _ref.isLoading;

  var _useState = (0, _react.useState)(isLoadingParam),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(isOpenParam),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1];

  var toggle = function toggle() {
    return setIsOpen(function (prev) {
      return !prev;
    });
  };

  return {
    isLoading: isLoading,
    isOpen: isOpen,
    toggle: toggle,
    setIsLoading: setIsLoading
  };
};

exports.useModal = useModal;

var Modal = function Modal(props) {
  var children = props.children,
      className = props.className,
      DynamicRender = props.dynamicRender,
      hasVariableHeight = props.hasVariableHeight,
      height = props.height,
      hide = props.hide,
      isLoading = props.isLoading,
      isOpen = props.isOpen,
      onClose = props.onClose,
      title = props.title,
      width = props.width,
      theme = props.theme;
  var isDynamicContent = !!DynamicRender;

  var _useState5 = (0, _react.useState)(isOpen),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      shouldShowModal = _useState6[0],
      setShouldShowModal = _useState6[1];

  var _theme$modal = theme.modal;
  _theme$modal = _theme$modal === void 0 ? {} : _theme$modal;
  var _theme$modal$settings = _theme$modal.settings;
  _theme$modal$settings = _theme$modal$settings === void 0 ? {} : _theme$modal$settings;
  var _theme$modal$settings2 = _theme$modal$settings.footer,
      footerEnabled = _theme$modal$settings2 === void 0 ? false : _theme$modal$settings2;
  (0, _react.useEffect)(function () {
    setShouldShowModal(isOpen);
  }, [isOpen]);

  var close = function close() {
    setShouldShowModal(false);

    if (onClose) {
      onClose();
    }

    if (hide) {
      hide();
    }
  };

  var modal = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Modal.StyledReactModal, {
    closeTimeoutMS: 500,
    className: className,
    contentLabel: title,
    height: height,
    hasVariableHeight: hasVariableHeight,
    isOpen: shouldShowModal,
    onRequestClose: close,
    width: width,
    theme: theme
  }, isLoading && /*#__PURE__*/_react["default"].createElement(_Modal.StyledModalLoading, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null))), /*#__PURE__*/_react["default"].createElement(_Modal.StyledModalHeader, {
    theme: theme,
    hasTitle: !!title
  }, title && /*#__PURE__*/_react["default"].createElement(_Modal.StyledModalTitle, {
    theme: theme
  }, title), /*#__PURE__*/_react["default"].createElement(_Modal.StyledCloseButton, {
    onClick: close,
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_MdClose.MdClose, null))), /*#__PURE__*/_react["default"].createElement(_Modal.StyledModalBody, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Modal.StyledModalContent, {
    footerEnabled: footerEnabled,
    hasTitle: !!title,
    theme: theme
  }, isDynamicContent ? /*#__PURE__*/_react["default"].createElement(DynamicRender, null) : children))));

  return modal;
};

Modal.defaultProps = {
  children: undefined,
  className: '',
  height: 400,
  hide: undefined,
  hasVariableHeight: false,
  isLoading: false,
  isOpen: false,
  dynamicRender: undefined,
  onClose: undefined,
  title: undefined,
  width: 600
};
Modal.propTypes = {
  /** Body of the modal */
  children: _propTypes.node,

  /** Pass a React component to render dynamic content */
  dynamicRender: _propTypes.func,

  /** Modal height in pixels or other units */
  height: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /** Defines if modal uses content height or set height */
  hasVariableHeight: _propTypes.bool,

  /** Defines if modal should be presented */
  isOpen: _propTypes.bool,

  /** Bool value that should come from the useModal state, visible here for plaground testing */
  isLoading: _propTypes.bool,

  /** Function to be called when the modal is closed */
  onClose: _propTypes.func,

  /** Title of the modal */
  title: _propTypes.string,

  /** Modal width in pixels or other units */
  width: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /** Function to be called to hide/close the modal */
  hide: _propTypes.func,
  theme: (0, _propTypes.shape)({}).isRequired,

  /** The class name you want to apply to the whole modal, also allows you to sub-select the children in your view */
  className: _propTypes.string
};
Modal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Modal",
  "props": {
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Body of the modal",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "The class name you want to apply to the whole modal, also allows you to sub-select the children in your view",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "400",
        "computed": false
      },
      "description": "Modal height in pixels or other units",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "hide": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Function to be called to hide/close the modal",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "hasVariableHeight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Defines if modal uses content height or set height",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isLoading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Bool value that should come from the useModal state, visible here for plaground testing",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Defines if modal should be presented",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "dynamicRender": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Pass a React component to render dynamic content",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClose": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Function to be called when the modal is closed",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "title": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Title of the modal",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "600",
        "computed": false
      },
      "description": "Modal width in pixels or other units",
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "string"
        }]
      },
      "required": false
    },
    "theme": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Modal);

exports["default"] = _default;